import React from "react";
import { formatDate } from "../../../utils/utils";
import MessageContent, { MessageStatus } from "../../../components/fragments/messageContent";

export default function ItemIn({
  item,
  index
}) {

    return (
        <>
            <div className="d-flex flex-row justify-content-end flex-end" key={index}>
                <div className={"float-end w-auto"}>
                    <p style={{ fontSize: 10 }} className="small mb-2 rounded-3 text-muted text-end">{item.uname + " • " + formatDate(item.createdat)}<MessageStatus item={item} /></p>
                </div>
            </div>
            <MessageContent item={item} variant="in" index={index} />
        </>
    )
}
